// extracted by mini-css-extract-plugin
export default {"dependents":"insurances_dependents__PJLfG","addButton":"insurances_addButton__ch35U"};